/* 頂部列自動讓位。

   店裡有 App（目前是 Vitals 的 Smart Bar）會用 JS 在畫面最上緣插一條固定的列。
   我們的頂部列也固定在最上緣，兩個疊在一起就整條被蓋住。

   這裡不寫死任何 App 的名字或高度——而是量「畫面最上緣有沒有別的固定橫條」，
   有的話就把自己往下挪到它下面。App 換了、關了、或後台預覽列出現，都自動跟著變。 */
if (!window.__tsTopbarInit) {
  window.__tsTopbarInit = 1;
  (function () {
    /* 把 App（Vitals）插在頁面最上面的行銷列藏起來——只有這一頁，其他頁照舊。
       不猜它的 class 名稱（那是 App 內部的，改版就失效），而是直接讀 App 自己的
       設定拿到那句文案，再從文字往上找到它的外層。找不到就什麼都不做。 */
    function hideAppBar() {
      var bar = document.querySelector(".ts-topbar");
      if (!bar || bar.dataset.hideApp !== "1") return false;
      var d = window.vtlsLiquidData, list = d && d.smartBar;
      if (!list || !list.length) return false;
      var msg = "";
      for (var n = 0; n < list.length && !msg; n++) {
        var m = (list[n].parameters || {}).message || {};
        msg = m["zh-TW"] || m.en || "";
      }
      if (!msg) return false;

      var content = document.querySelector(".ts-air");
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), node;
      while ((node = w.nextNode())) {
        if (node.nodeValue.indexOf(msg) < 0) continue;
        var el = node.parentElement;
        while (el && el.parentElement && el.parentElement !== document.body) el = el.parentElement;
        // 三道保險：不能是我自己、不能包住頁面內容、不能是整頁那麼高的東西
        if (!el || el === bar || el.contains(bar)) return false;
        if (content && el.contains(content)) return false;
        if (el.getBoundingClientRect().height > 240) return false;
        el.style.display = "none";
        return true;
      }
      return false;
    }

    function place() {
      hideAppBar();
      var bar = document.querySelector(".ts-topbar");
      if (!bar) return;
      bar.style.top = "0px";                       // 先歸零再量，不然會越推越low
      var spacer = document.querySelector(".ts-topbar__spacer");
      var mine = bar.getBoundingClientRect();
      var offset = 0;

      var all = document.body.querySelectorAll("*");
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el === bar || bar.contains(el) || el.contains(bar)) continue;
        var cs = getComputedStyle(el);
        if (cs.position !== "fixed" && cs.position !== "sticky") continue;
        if (cs.display === "none" || cs.visibility === "hidden") continue;
        var r = el.getBoundingClientRect();
        // 只認「貼在最上緣、橫跨整個畫面、又不太高」的橫條
        if (r.top <= 2 && r.height > 4 && r.height < 220 &&
            r.width > innerWidth * 0.6 && r.bottom > offset) {
          offset = r.bottom;
        }
      }
      bar.style.top = offset + "px";
      if (spacer) spacer.style.height = mine.height + "px";
    }

    function watch() {
      place();
      // App 是非同步插進來的，載入後還會再動，所以多量幾次
      [150, 500, 1200, 2500, 4000].forEach(function (t) { setTimeout(place, t); });
      addEventListener("resize", place);
      if (window.ResizeObserver) {
        try { new ResizeObserver(place).observe(document.body); } catch (e) {}
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", watch);
    } else {
      watch();
    }
    addEventListener("load", place);
  })();
}
